import React, { useState } from 'react'
import { makeStyles } from 'transfix-ui/core'
import { IGetInboundSftpFilesReport, Maybe } from 'types/graphqlTypes'
import { Button, theme } from 'transfix-ui'
import { useInboundSftpFiles } from '../hooks/useInboundSftpFiles'
import { InboundSftpFilesTable } from './InboundSftpFilesTable'

interface IInboundSftpFilesListProps {
  /**
   * @example '25'
   */
  inboundConnectionConfigId: string
}

const useInboundSftpFilesStyles = makeStyles({
  container: {
    marginTop: theme.spacing(2),
  },
})

export const InboundSftpFiles = ({ inboundConnectionConfigId }: IInboundSftpFilesListProps) => {
  const [inboundSftpFilesReport, setInboundSftpFilesReport] = useState<
    Maybe<IGetInboundSftpFilesReport>
  >()

  const classes = useInboundSftpFilesStyles()

  const { inboundSftpFiles } = useInboundSftpFiles()

  const clickHandler = async () => {
    const report = await inboundSftpFiles({
      inboundConnectionConfigId,
    })
    setInboundSftpFilesReport(report)
  }

  return (
    <div>
      <Button
        color='primary'
        size='small'
        data-test='list-inbound-sftp-files-btn'
        onClick={clickHandler}>
        {inboundSftpFilesReport ? 'Refresh' : 'Load Files'}
      </Button>
      {inboundSftpFilesReport && (
        <div className={classes.container}>
          <InboundSftpFilesTable
            report={inboundSftpFilesReport}
            inboundConnectionConfigId={inboundConnectionConfigId}
          />
        </div>
      )}
    </div>
  )
}
